import {createSelector} from 'reselect';

const filterSelector = state => state.filters;

export const selectProjectFilters =createSelector(
    filterSelector,
    filters => filters.projects
)

export const selectProjectFiltersApplied = createSelector(
    filterSelector,
    filters => filters.projects.appliedFilters
)

export const selectTotalProjectFilterOptions = createSelector(
    filterSelector,
    filters => filters.projects.totalFilterOptions
)

export const selectProjectFiltersConjunctionSelection = createSelector(
    filterSelector,
    filters => filters.projects.conjunctionSelection
)

export const selectTaskFilters =createSelector(
    filterSelector,
    filters => filters.tasks
)

export const selectTaskFiltersApplied = createSelector(
    filterSelector, 
    filters => filters.tasks.appliedFilters
)

export const selectTotalTaskFilterOptions = createSelector(
    filterSelector,
    filters => filters.tasks.totalFilterOptions
)

export const selectTaskFiltersConjunctionOptions = createSelector(
    filterSelector,
    filters => filters.tasks.conjunctionOptions
)
